import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    text: {
        marginTop : theme.spacing(10),
        textAlign : "center"
    }
}))

export default useStyles